import moment from 'moment';

// A teammate's presence for direct message headers: Online, Last seen …, or Offline
export const getOnlineStatus = (user) => {
	if (!user) {
		return '';
	}

	if (user.isOnline) {
		return 'Online';
	}

	if (!user.lastOnlineAt) {
		return 'Offline';
	}

	return `Last seen ${moment(user.lastOnlineAt).fromNow()}`;
};
